import { FC, useCallback } from 'react';
import { difference } from 'lodash';

import { FacetKey, facetsOrder } from '@app/components';

import { useFilterPanelContext } from '../FilterPanelContext';
import { Facet } from '../Facet';

export const Facets: FC = () => {
  const {
    facets,
    facetsToFetch,
    getActiveFacetAttributesCount,
    setStatePristine,
    setFacetsToFetch,
  } = useFilterPanelContext();
  const expandFacet = useCallback(
    (facetKey: FacetKey) => {
      const wasFacetExpandedBefore = facetsToFetch.includes(facetKey);

      if (!wasFacetExpandedBefore) {
        setStatePristine(false);
        setFacetsToFetch(prevState => prevState.concat(facetKey));
      }
    },
    [setFacetsToFetch, setStatePristine, facetsToFetch]
  );

  const closeFacet = useCallback(
    (facetKey: FacetKey) => {
      if (!getActiveFacetAttributesCount(facetKey)) {
        setFacetsToFetch(prevState => difference(prevState, [facetKey]));
      }
    },
    [setFacetsToFetch, getActiveFacetAttributesCount]
  );

  return (
    <>
      {facetsOrder.map(facetKey => {
        if (!facets[facetKey]) {
          return null;
        }

        const { label, values, isError = false } = facets[facetKey];

        const activeFacetAttributesCount =
          getActiveFacetAttributesCount(facetKey);
        const isFacetExpanded = activeFacetAttributesCount > 0;

        return (
          <Facet
            key={facetKey}
            label={label}
            values={values}
            facetKey={facetKey}
            activeFacetAttributesCount={activeFacetAttributesCount}
            isInitiallyExpanded={isFacetExpanded}
            isError={isError}
            expandFacet={expandFacet}
            closeFacet={closeFacet}
          />
        );
      })}
    </>
  );
};
